import { render } from "./CompletedLogs.vue?vue&type=template&id=2fd47f7d&scoped=true"
import script from "./CompletedLogs.vue?vue&type=script&lang=js"
export * from "./CompletedLogs.vue?vue&type=script&lang=js"

import "./CompletedLogs.vue?vue&type=style&index=0&id=2fd47f7d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd47f7d"]])

export default __exports__